/* 🤖 this file was generated by svg-to-ts */
export const kzIconsAttachment: {
  name: 'attachment';
  data: string;
} = {
  name: 'attachment',
  data: `<svg fill="none" viewBox="0 0 24 24"><path d="m20 11.953-7.564 7.565a4.941 4.941 0 0 1-6.989-6.989l7.565-7.564a3.294 3.294 0 0 1 4.659 4.659l-7.573 7.564a1.647 1.647 0 1 1-2.33-2.33l6.989-6.98" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};
